import { 
	Button, 
} from 'react-bootstrap';
import styled from 'styled-components';
import DisableBackground from '../../atoms/DisableBackground/index';
import {RemoveIcon , MenuRightIcon, MenuDownIcon, PlusIcon, MinusIcon} from '../../atoms/Icons';
import IconButton from '../../atoms/IconButton';
import {ArrowExpander} from '../../atoms/Expander/index';
import { OnPrimary,DefaultPrimaryColor,DividerColor,Grey700,ColorDefs, OnSurface } from '../../Colors';
import TextButton from '../../atoms/TextButton/index';
import Checkbox from '../../atoms/Checkbox';
import Help from './Help';

export default {
	ModalTitleInput : styled.input`
		appearance: none;
		margin: 0;
		padding: 0;
		background: none;
		border: none;
		border-radius: 0;
		outline: none;
		width:50%;
		font-size:2em;
		transition: width .3s;
		&:focus{
			  border-bottom: 1px solid #ccc;
			  width: 75%;
		}
	`,
	Header : styled.div`

	`,
	BodyWrapper : styled.div`
		flex-direction: row;
		display:flex;
		position : relative;
		`,
	EditorWrapper : styled.div`
		flex-direction: column;
		display:flex;
		flex-grow : 8;
		height:100%;
		padding : 1rem;
		`,
	Help : styled(Help)`
		margin-bottom : 1rem;
	`,
	Hr : styled.hr.attrs({width:'100%'})`
	`,
	ExplanationWrapper : styled.div`
		padding-left : 1rem;
		&:focus-within{
			border-left : 1px solid  ${DividerColor};
			color : ${OnSurface};
		}
		&:hover{
			border-left : 1px solid  ${DividerColor};
		}
	`,
	Explanation : styled.textarea`
		border : none;
		width : 100%;
		&:focus{
			outline : 0;
		}
	`,
	PreviewFlexBox : styled.div`
		display:flex;
		flex-direction: row;
		justify-content: space-between;
		overflow: auto;
	`,
	AnswerOptionCloseutton : styled(Button)`
		position: absolute;
		top: 2px;
    	right: 2px;
	`,
	AnswerText : styled.span`
		color:red;
		font-weight: bold;
	`,
	MenuItem : styled.div`
		position: relative;
	`,
	DisableBackground : styled(DisableBackground)`
		height : 100%;
	`,
	AnswerOptionOutline : styled.div`
		padding : 10px;
		min-width : 300px;
		max-width : 300px;
		border-left : solid 1px ${DividerColor};
	`,
	AnswerOptionHeader : styled.div`
		background-color : ${DefaultPrimaryColor};
		border-radius : 5px;
		color : ${OnPrimary};
		text-align: center;
		position : relative;
	`,
	Footer : styled.div`
		display : flex;
		align-items : center;
		justify-content: flex-end;
		&>:first-child{
			margin-right: auto;
		}
	`,
	Checkbox : styled(Checkbox).attrs({
		color : ColorDefs.secondary
	})`
		color : ${Grey700};
	`,
	CloseIcon : styled(RemoveIcon)`
		color : ${OnPrimary};
	`,
	CloseIconButton : styled(IconButton)`
		position : absolute;
		top : 0;
		right: 0;
	`,
	TextButton : styled(TextButton)`
		padding : 1rem 0 1rem 0;
		&:focus{
			outline : 0;
			border : none;
			background-color : transparent;
		}
		&:hover{
			background-color : transparent;
			border : none;
		}
	`,
	PlusIcon : styled(PlusIcon)`
		margin-right : 0.5rem;
	`,
	MinusIcon : styled(MinusIcon)`
		margin-right : 0.5rem;
	`,
	ArrowExpander : styled(ArrowExpander)`
		margin-top : 1rem;
	`,
	mobile : {
		AnswerOptionHeader : styled.div`
			position : relative;
		`,
		ShowAnswerButton : styled(TextButton)`
			text-align : left;
			display : block;
			padding-left : 0;
		`,
		MenuRightIcon : styled(MenuRightIcon)`
			padding-left : 0.5rem;
			margin-right : 1rem;
		`,
		MenuDownIcon : styled(MenuDownIcon)`
			margin-right : 1rem;
			padding-left : 0.5rem;
		`,
	}
};